// extracted by mini-css-extract-plugin
module.exports = {"new-logo":"new-logo--05ed8","newLogo":"new-logo--05ed8","old-logo":"old-logo--021c4","oldLogo":"old-logo--021c4"};